var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMountains2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 709,
    height: 195,
    viewBox: "0 0 709 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M598.67 193.989C598.67 193.989 675.93 202.515 700.525 170.26C732.433 128.413 666.878 96.6844 616.602 102.595C507.047 115.477 508.415 -74.7815 359.945 33.4264C320.665 62.0499 267.722 10.7077 203.623 74.0788C188.644 88.8909 97.091 60.2675 51.5276 71.9851C-37.6437 94.9229 3.12938 194.376 66.8451 194.766C130.561 195.156 598.67 193.989 598.67 193.989Z",
    fill: "#E4E6EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M411.436 65.6128C411.974 63.1735 412.973 60.8719 414.373 58.8439C415.774 56.816 417.549 55.1029 419.592 53.8058C421.635 52.5086 423.905 51.6537 426.269 51.2915C428.632 50.9293 431.041 51.0672 433.353 51.6971C436.049 45.6607 440.739 40.8516 446.556 38.1588C452.373 35.466 458.924 35.0716 464.997 37.0485C468.157 31.5556 472.736 27.1123 478.204 24.2325C483.672 21.3527 489.806 20.1541 495.897 20.7751C501.988 21.3961 507.787 23.8114 512.623 27.7417C517.459 31.6721 521.135 36.957 523.226 42.9853C526.611 41.0116 530.43 39.9988 534.303 40.0473C538.176 40.0958 541.97 41.204 545.309 43.2619C548.648 45.3199 551.417 48.2563 553.34 51.7805C555.264 55.3046 556.275 59.2942 556.276 63.3543C556.276 64.117 556.238 64.8716 556.17 65.6154L411.436 65.6128Z",
    fill: "#F7F9FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains2);
export default __webpack_public_path__ + "static/media/mountains-2.80897550784d4ab0a8ed411717c42165.svg";
export { ForwardRef as ReactComponent };